import {
  getEventDispatcherHandlerInstance,
  getAmplitudeEventDispatcherInstance,
} from '@quintoandar/event-tracker-core';

import { getLoggedUser } from 'Base/Security/user';
import { trackingConfig } from '../trackingConfig';

const isEventTrackingEnabled = process.env.ENABLE_EVENT_TRACKING === 'true';

export const useEventDispatcherHandler = () => {
  if (!isEventTrackingEnabled) return null;

  const amplitudeEventDispatcher = getAmplitudeEventDispatcherInstance(
    getLoggedUser,
    trackingConfig.amplitudeConfig,
    trackingConfig.globalConfig,
  );

  const handlers = {
    amplitudeEventDispatcher,
  };

  return getEventDispatcherHandlerInstance(
    handlers,
    trackingConfig.globalConfig,
  );
};
